import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type SummaryClickEventParams = {
	eventAction: EventAction;
	eventName: string;
	elementName?: string;
	componentName: string;
	label?: string;
	targetURL?: string;
	clickID?: string;
	value?: string;
	pos?: string;
	relatedElements?: {
		elementName: string;
		elementValue: string;
	}[];
};

export class SummaryClickEvent extends BaseEvent {
	constructor({
		eventAction,
		eventName,
		elementName = 'text link',
		componentName,
		label = '',
		targetURL = '',
		clickID = '',
		value = '',
		pos = '',
		relatedElements,
	}: SummaryClickEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName,
			},
			attributes: {
				componentName,
				label,
				targetURL,
				elementName,
				clickID,
				value,
				pos,
				...(relatedElements && { relatedElements: relatedElements.length ? [relatedElements[0]] : undefined }),
			},
			updatePageInfo: {
				page: {
					pageInfo: {
						referringURL: window && window.location ? window.location.href : '',
					},
				},
			},
		});
	}
}
